import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c9c8c6d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "absolute_control_features" };
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "absolute_control_features__screen" };
const _hoisted_4 = ["src"];
const _hoisted_5 = { class: "absolute_control_features__grid" };
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = { class: "absolute_control_features__item--content" };
const _hoisted_8 = ["innerHTML"];
import { onMounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'absolute_control_features',
    props: {
        d: {}
    },
    setup(__props) {
        const videoElement = ref(null);
        onMounted(() => {
            const options = {
                threshold: 0.7, // Trigger when 70% of the video is in view
            };
            const videoObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Video is in view, start playing
                        videoElement.value.play();
                    }
                    else {
                        // Pause the video when it's out of view (optional)
                        videoElement.value.pause();
                    }
                });
            }, options);
            // Start observing the video element
            if (videoElement.value) {
                videoObserver.observe(videoElement.value);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("video", {
                            class: "no-controls",
                            ref_key: "videoElement",
                            ref: videoElement,
                            src: _ctx.d.video,
                            muted: "",
                            playsinline: ""
                        }, null, 8, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.d.absolute_control_features_repeatable, (feature, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "absolute_control_features__item"
                            }, [
                                _createElementVNode("img", {
                                    src: feature.image,
                                    alt: feature.title,
                                    loading: "lazy"
                                }, null, 8, _hoisted_6),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("h3", null, _toDisplayString(feature.title), 1),
                                    _createElementVNode("p", {
                                        innerHTML: feature.description
                                    }, null, 8, _hoisted_8)
                                ])
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
